export enum ToastTypesEnum {
  success = 'success',
  error = 'error',
}
